// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Izok3","rotate":"Loader_rotate__m-QJf","prixClipFix":"Loader_prixClipFix__N2t2-"};